import '../../stylesheets/sessions/page';
//---------views/sessions/new.html.slimに記載